import { render, staticRenderFns } from "./Bloque.vue?vue&type=template&id=6c9ec0ab"
import script from "./Bloque.vue?vue&type=script&lang=js"
export * from "./Bloque.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports